<template>
  <base-widget
    title="Activity"
    :items="userActivityTabNames()"
    :style="heightStyles"
    scrollable
    @tabChanged="onTabChange"
  >
    <template #default="{ current }">
      <component
        :is="getActivityTabComponent(userActivityTabNames()[current])"
      />
    </template>
    <!--
    <shopping-list v-show="currentTab === 0" />
    <views-list v-show="currentTab === 1" />
    -->
  </base-widget>
</template>

<script>
import integrable from '@/components/mixins/integrable';
import ShoppingList from './Activity/ShoppingList';
import ViewsList from './Activity/ViewsList';
import minHeightMixin from '../mixins/minheight';

export default {
  name: 'ActivityContainer',
  components: {
    ShoppingList,
    ViewsList,
  },
  mixins: [minHeightMixin, integrable],
  data() {
    return {
      currentTab: 0,
    };
  },
  computed: {

  },
  methods: {
    onTabChange(evt) {
      this.currentTab = evt;
    },
  },
};
</script>
